import styled from 'styled-components';


export const FiltersWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end!important;
	padding: 15px 0;
	label{
		display: block;
		margin-bottom: 0px;
		font-weight: bold
	}
`;